import { Link } from '@tanstack/react-router';
import { Compass } from 'lucide-react';
import { Button, EmptyState } from '@kidova/ui-web';
import { useI18n } from '../i18n';

export function NotFound() {
  const { t } = useI18n();
  return (
    <main className="flex min-h-dvh items-center justify-center p-6">
      <EmptyState
        icon={Compass}
        headingLevel={2}
        title={t('error.notFound.title')}
        description={t('error.notFound.body')}
        actions={
          <Button asChild>
            <Link to="/">{t('error.notFound.action')}</Link>
          </Button>
        }
      />
    </main>
  );
}
